
export { useWalletWithdrawRecipient } from "/home/runner/work/capsicum/capsicum/libs/features/wallet/shared/src/hooks/useWalletWithdrawRecipient.ts"